import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/profile.svg';

export const IconProfile: IconComponent = props => <Icon {...props} src={src} />;
